import styled from "styled-components";
import { colors2 } from "oolib";
import { globalScrollbarStyling } from "oolib/dist/v2/themes/globalStyles";

/**
 * ─────────────────────────────────────────────────────────────────────────
 *  Dev-2 OWNS THIS FILE (styling of the CascadeFieldPicker).
 *  Dev-1 seeded minimal, functional styles so the picker works end-to-end;
 *  Dev-2 refines spacing / motion / states with the designer. Logic lives in
 *  index.js + comps/*.js + utils/* (Dev-1) and must not move here.
 * ─────────────────────────────────────────────────────────────────────────
 */

// Root + folder panel scroll containers. Mirrors the DocHierarchyFilter panel.
export const StyledScrollWrapper = styled.div`
  overflow: auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
  ${globalScrollbarStyling}
`;

export const StyledOuterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1;
`;

export const SECTION_LABEL_STYLE = {
  padding: "0.6rem 0.8rem 0.4rem 0.8rem",
  color: colors2.grey50,
  display: "block",
};

export const StyledSectionDivider = styled.div`
  margin: 0.4rem 0;
`;

export const StyledEmpty = styled.div`
  padding: 1.2rem 0.8rem;
  color: ${colors2.grey50};
  font-style: italic;
`;
